const defaultSortingColumns = {
  PublisherUsagePerformanceReport: 'Impressions',
  AccountPerformanceReport: 'Clicks',
  CampaignPerformanceReport: 'Clicks',
  AdGroupPerformanceReport: 'Clicks',
  AdPerformanceReport: 'Clicks',
  KeywordPerformanceReport: 'Clicks',
  SearchQueryPerformanceReport: 'Clicks',
  DestinationURLPerformanceReport: 'Clicks',
  AudiencePerformanceReport: 'Clicks',
  FeedItemPerformanceReport: 'Clicks',
  InsertionOrderReport: 'IOReportMonth',
};

export const getDefaultSortingColumn = (reportType) => {
  // report does not have a default sorting column
  if (!reportType || !defaultSortingColumns[reportType]) {
    return {};
  }

  return {
    key: defaultSortingColumns[reportType],
    isSortedDescending: true,
  };
};
